import {Component, Inject } from '@angular/core';
import {NotificationService} from 'src/app/core/services/notification.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-sms-result-dialog',
  templateUrl: './sms-result-dialog.component.html',
  styleUrls: ['./sms-result-dialog.component.scss']
})
export class SmsResultDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SmsResultDialogComponent>,
    public notificationService: NotificationService,
  ) {
    dialogRef.disableClose = false;
    this.dataSource = this.data.smsResult
  }
  dataSource: any;

  public displayedColumns = [
    'id',
    'customer',
    'status',
    'note'
  ];

  onNoClick() {
    this.dialogRef.close();
  }

}
